import React, { PropsWithChildren, useCallback } from "react";
import { usePopover } from "providers/PopoverProvider";
import ContextMenuList from "components/ContextMenu/ContextMenuList";
import { APP_URL, getAppUrl } from "utils/defines";
import { Logo } from "./Logo";
import useTranslation from "utils/hooks/useTranslation";
import { useSalesNetwork } from "utils/hooks/useSalesNetworks";
import { useAuth } from "utils/hooks/useAuth";
import { Link } from "react-router";
import parse from "html-react-parser";
import { SvgHome } from "components/svg";
import { useGetLinksQuery } from "store/api";

const Header: React.FC<PropsWithChildren> = () => {
  const { open } = usePopover();
  const { setLanguage, language } = useTranslation();
  const { network } = useSalesNetwork();
  const { t } = useTranslation();

  const { firstName, lastName, isAuth } = useAuth();

  const languages = network?.languages;
  const contact = network?.contact;

  const { data: links } = useGetLinksQuery(
    { code: network?.code ?? "" },
    { skip: !network?.code }
  );

  const onQuestionClick = useCallback(
    (e: React.MouseEvent) => {
      open({
        element: (e.target as any).closest("[data-popover-trigger]"),
        content: (
          <ContextMenuList
            items={
              contact
                ? [
                  {
                    element: (
                      <>
                        <icon></icon>
                        <text
                          data-opacity="60"
                          data-wrap="preline"
                          data-space-vertical="20"
                          data-space="20"
                          data-link=""
                        >
                          {parse(contact)}
                        </text>
                      </>
                    ),
                  },
                  { separator: true },
                  { text: "FAQ", link: getAppUrl(APP_URL.FAQ) },
                  { text: "CGU", link: getAppUrl(APP_URL.CGU) },
                ]
                : [
                  { text: "FAQ", link: getAppUrl(APP_URL.FAQ) },
                  { text: "CGU", link: getAppUrl(APP_URL.CGU) },
                ]
            }
          />
        ),
      });
    },
    [contact, open]
  );

  const onLanguageDropdownClick = useCallback(
    (e: React.MouseEvent) => {
      if (!languages) {
        return;
      }

      open({
        element: (e.target as any).closest("[data-popover-trigger]"),
        content: (
          <ContextMenuList
            items={languages.map((l) => ({
              text: l.label,
              onClick: () => setLanguage(l.code),
            }))}
          />
        ),
      });
    },
    [languages, open, setLanguage]
  );

  return (
    <group data-index="2">
      <group
        data-align="center"
        data-wrap="no"
      // data-color="white"
      //data-background="main"
      >
        <group
          data-align="center"
          className="desk"
          data-wrap="no"
          // data-gap="10"
          data-min-length="240"
          data-width="auto"
          data-height="fit"
        >
          <Logo />
        </group>
        {/* <group
          data-height="fit"
          data-length="5"
          data-background="main-light"
        ></group> */}
        <group data-width="auto"></group>
        {(() => {
          const infoNews = t("FO_INFO_NEWS");
          const isTranslated = infoNews !== "FO_INFO_NEWS";
          const isAcvfr = network?.code === "ACVFR";

          if (!isTranslated) {
            return (
              <group
                data-align="center"
                data-justify="start"
                data-text-size="14"
              />
            );
          }

          return (
            <group
              data-align="start"
              data-justify="center"
              data-text-size={isAcvfr ? "16" : "10"}
              data-direction="column"
              data-length="400"
              {...(isAcvfr ? { "data-color": "accent-dark" } : {})}
            >
              <div dangerouslySetInnerHTML={{ __html: infoNews }} />
            </group>
          );
        })()}
        <group
          data-position="right"
          data-wrap="no"
          data-height="fit"
          data-length="autofit"
          data-name="navigation"
          data-text-size="large"
          data-justify="end"
        >
          <group>

            {links && links.length > 0 && (
              <group data-wrap="no" data-align="center" data-gap="5" data-space-horizontal="5" data-justify="end">
                {links.map((link) =>
                  link.logoBase64 && link.url ? (
                    <a
                      key={link.id}
                      href={link.url}
                      target="_blank"
                      rel="noreferrer"
                      // rel="noopener noreferrer"
                      title={`${link.name}\n${link.description ?? ""}`}
                      data-height="fit"
                      style={{ display: "flex", alignItems: "center", zIndex: 1000 }}
                    >
                      <picture data-height="40" data-max-length="120" data-width="auto">
                        <img
                          src={link.logoBase64}
                          alt={link.name ?? ""}
                        />
                      </picture>
                    </a>
                  ) : null
                )}
              </group>

            )}

          </group>
          <group
            data-cursor="pointer"
            data-align="center"
            data-justify="center"
            data-fit="1"
            data-interactive=""
            data-max-length="100"
          >
            <Link to="">
              <icon data-svg-size="40" data-color="accent-dark">
                <SvgHome />
              </icon>
            </Link>
          </group>

          {isAuth && (
            <group
              data-cursor="pointer"
              data-align="center"
              data-justify="center"
              data-fit="1"
              data-max-length="180"
              data-interactive=""
            >
              <Link to={getAppUrl(APP_URL.MyEtudes)}>
                <group
                  data-align="center"
                  data-justify="center"
                  data-width="auto"
                  data-space="10"
                  data-space-horizontal="15"
                  data-gap="5"
                  data-wrap="no"
                >
                  <icon>list</icon>
                  <group data-direction="column">
                    <text>{t("FO_HEADER_STUDIES")}</text>
                    {/* <text>Mes</text>
                      <text data-weight="800">études</text> */}
                  </group>
                </group>
              </Link>
            </group>
          )}
          {isAuth && (
            <group
              onClick={onQuestionClick}
              data-popover-trigger
              data-cursor="pointer"
              data-align="center"
              data-justify="center"
              data-fit="1"
              data-max-length="180"
              data-interactive=""
            >
              <group
                data-align="center"
                data-justify="center"
                data-width="auto"
                data-space="10"
                data-space-horizontal="15"
                data-gap="5"
                data-wrap="no"
                data-interactive-type="material-border"
              >
                <icon>help</icon>
                <group data-direction="column">
                  <text>{t("FO_HEADER_HELP")}</text>
                </group>
              </group>
            </group>
          )}

          {isAuth && (
            <group
              data-cursor="pointer"
              data-align="center"
              data-justify="center"
              data-fit="1"
              data-max-length="200"
              data-name="navigation-item-implex"
              data-wrap="no"
              data-interactive=""
            >
              <separator
                data-vertical=""
                data-height="fit"
                data-margin="0"
              ></separator>
              <Link
                data-type="group"
                data-height="fit"
                data-align="center"
                data-gap="5"
                to={getAppUrl(APP_URL.Profile)}
              >
                <group
                  // onClick={onProfileClick}
                  data-popover-trigger
                  data-space-horizontal="15"
                  data-align="center"
                  data-justify="center"
                  data-interactive=""
                  //data-interactive-type="material-border"
                  data-direction="column"
                  data-height="fit"
                >
                  <group
                    data-align="center"
                    data-justify="center"
                    data-space-horizontal="20"
                    data-height="fit"
                    data-duration=".5"
                    data-type="interact"
                    data-width="auto"
                    data-length="autofit"
                  >
                    {!firstName && !lastName ? (
                      <text>{t("FRONT_ACCOUNT") || "FRONT_ACCOUNT"}</text>
                    ) : (
                      <>
                        {(() => {
                          const fullLength =
                            (firstName?.length || 0) + (lastName?.length || 0);

                          if (firstName?.length > 17 || lastName?.length > 17) {
                            // show only last name with ellips
                            return <text data-ellipsis>{lastName}</text>;
                          }

                          if (fullLength > 17) {
                            // show full name but wrapped
                            return (
                              <text data-wrap="wrap">
                                {firstName} {lastName}
                              </text>
                            );
                          }

                          // normal case
                          return (
                            <text>
                              {firstName} {lastName}
                            </text>
                          );
                        })()}
                      </>
                    )}
                  </group>
                  <group
                    data-duration=".5"
                    data-type="interact-border"
                    data-background="main"
                    data-height="5"
                    data-radius-top="10"
                  ></group>
                </group>
              </Link>
              <separator
                data-vertical=""
                data-height="fit"
                data-margin="0"
              ></separator>
            </group>
          )}

          <group
            data-cursor="pointer"
            data-align="center"
            data-justify="center"
            data-fit="1"
            data-max-length="100"
            data-name="navigation-item-implex"
            data-wrap="no"
          >
            <group
              data-popover-trigger
              onClick={onLanguageDropdownClick}
              data-space-horizontal="15"
              data-justify="center"
              data-interactive=""
              data-interactive-type="material-border"
              data-direction="column"
              data-height="fit"
            >
              <group
                data-gap="5"
                data-wrap="no"
                data-align="center"
                data-justify="center"
                data-space="10"
                data-space-horizontal="20"
                data-height="fit"
                data-duration=".5"
                data-type="interact"
                data-width="auto"
                data-length="autofit"
              >
                <icon>expand_more</icon>
                <text>{language}</text>
              </group>
              <group
                data-duration=".5"
                data-type="interact-border"
                data-background="main"
                data-height="5"
                data-radius-top="10"
              ></group>
            </group>
            <separator
              data-vertical=""
              data-height="fit"
              data-margin="0"
            ></separator>
          </group>
        </group>
      </group>
    </group>
  );
};

export default Header;
